var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextarrw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18065 13.5833C0.961383 13.364 0.94145 13.0209 1.12085 12.7791L1.18065 12.7098L6.50817 7.38201L1.18065 2.05421C0.961383 1.83494 0.94145 1.49182 1.12085 1.25003L1.18065 1.18076C1.39993 0.961484 1.74305 0.94155 1.98484 1.12095L2.05411 1.18076L7.81864 6.94528C8.03791 7.16455 8.05784 7.50767 7.87844 7.74947L7.81864 7.81874L2.05411 13.5833C1.81291 13.8245 1.42185 13.8245 1.18065 13.5833Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextarrw);
export default __webpack_public_path__ + "static/media/nextarrw.5b2750b88b9d7eab5245f35454d907cb.svg";
export { ForwardRef as ReactComponent };